import React, { useEffect, useState } from "react";
import { BASE_CRM_URL } from "../../../../../components/config/config";
import Table from "../../../../../../core/pagination/datatable";
import PropTypes from "prop-types";
import NewTask from "../../../Tasks/NewTask";
import { Spin, Select, Tooltip, message } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router-dom";

import TaskDetailDrawer from "../../../Tasks/TaskDetailDrawer";

const Tasks = ({ recordId, type }) => {
  console.log(typeof recordId, recordId);
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (text, record) => (
        <Tooltip title={text}>
          <span
            onClick={(event) => {
              event.preventDefault();
              openTaskDetail("view", record);
            }}
             style={{ cursor: "pointer" }}
          >
            {text?.length > 45 ? `${text.substring(0, 45)}...` : text || "N/A"}
          </span>
        </Tooltip>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",

      render: (status, record) => {
        const isUpdating = updatingStatusTaskId === record.id;

        const getStatusColor = (statusName) => {
          switch (
            String(statusName || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "complete":
            case "completed":
              return "#198754";

            case "testing":
              return "#0d6efd";

            case "inprogress":
              return "#ffc107";

            case "notstarted":
              return "#dc3545";

            case "awaitingfeedback":
              return "#0dcaf0";

            default:
              return "#6c757d";
          }
        };

        const statusSelectOptions = taskStatusOptions.map((option) => ({
          value: option.Id,
          label: option.Status,
        }));

        const selectedStatus = taskStatusOptions.find(
          (option) => Number(option.Id) === Number(record.statusId),
        );

        const statusColor = getStatusColor(selectedStatus?.Status || status);

        return (
          <Select
            value={selectedStatus ? record.statusId : undefined}
            size="small"
            loading={statusOptionsLoading || isUpdating}
            disabled={statusOptionsLoading || isUpdating}
            style={{
              width: 125,
            }}
            styles={{
              selector: {
                border: `1px solid ${statusColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={statusSelectOptions}
            onChange={(newStatusId) => {
              if (Number(newStatusId) === Number(record.statusId)) {
                return;
              }

              updateTaskStatus(record.id, newStatusId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getStatusColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: statusColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedStatus?.Status || status || "Select Status"}
                </span>
              </div>
            )}
          />
        );
      },
    },
    {
      title: "Start Date",
      dataIndex: "startdate",
      sorter: (a, b) => new Date(a.startdate) - new Date(b.startdate),
      render: (date) => (
        <span>
          {/* <CalendarOutlined className="me-1 text-primary" /> */}
          {date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },

    {
      title: "Due Date",
      dataIndex: "duedate",
      sorter: (a, b) => new Date(a.duedate) - new Date(b.duedate),
      render: (date) => (
        <span>
          {/* <CalendarOutlined className="me-1 text-danger" /> */}
          {date ? dayjs(date).format("DD-MM-YYYY") : "N/A"}
        </span>
      ),
    },

    {
      title: "Assigned",
      dataIndex: "staff_names",

      render: (assignedTo) => {
        const staffList = Array.isArray(assignedTo)
          ? assignedTo
          : typeof assignedTo === "string"
            ? assignedTo
                .split(",")
                .map((name) => name.trim())
                .filter(Boolean)
            : [];

        return (
          <div className="avatar-list-stacked d-flex">
            {staffList.length > 0 ? (
              staffList.map((name, index) => {
                const color = avatarColors[index % avatarColors.length];

                return (
                  <span
                    key={`${name}-${index}`}
                    className="avatar avatar-rounded fw-bold d-flex justify-content-center align-items-center"
                    style={{
                      width: 35,
                      height: 35,
                      fontSize: 14,
                      backgroundColor: color.background,
                      color: color.color,
                    }}
                    title={name}
                  >
                    {name.charAt(0).toUpperCase()}
                  </span>
                );
              })
            ) : (
              <span className="text-muted">N/A</span>
            )}
          </div>
        );
      },

      sorter: (a, b) => {
        const getStaffCount = (staffNames) => {
          if (Array.isArray(staffNames)) {
            return staffNames.length;
          }

          if (typeof staffNames === "string") {
            return staffNames
              .split(",")
              .map((name) => name.trim())
              .filter(Boolean).length;
          }

          return 0;
        };

        return getStaffCount(a.staff_names) - getStaffCount(b.staff_names);
      },
    },

    {
      title: "Priority",
      dataIndex: "priority_name",

      sorter: (a, b) =>
        String(a.priority_name || "").localeCompare(
          String(b.priority_name || ""),
        ),

      render: (priorityName, record) => {
        const currentPriorityId = record.priority
          ? Number(record.priority)
          : undefined;

        const isRowUpdating = updatingPriorityTaskId === record.id;

        const getColor = (priority) => {
          switch (
            String(priority || "")
              .toLowerCase()
              .replace(/\s+/g, "")
          ) {
            case "low":
              return "#198754"; // green

            case "medium":
              return "#ffc107"; // yellow

            case "high":
              return "#fd7e14"; // orange

            case "urgent":
              return "#dc3545"; // red

            default:
              return "#6c757d"; // gray
          }
        };

        const selectedPriority = priorityOptions.find(
          (item) => Number(item.priorityid) === Number(currentPriorityId),
        );

        const priorityColor = getColor(selectedPriority?.name || priorityName);

        return (
          <Select
            value={selectedPriority ? currentPriorityId : undefined}
            size="small"
            loading={priorityOptionsLoading || isRowUpdating}
            disabled={isRowUpdating || priorityOptionsLoading}
            style={{
              width: 100,
            }}
            styles={{
              selector: {
                border: `1px solid ${priorityColor}`,
                borderRadius: "6px",
              },
            }}
            dropdownStyle={{
              zIndex: 9999,
            }}
            options={priorityOptions.map((option) => ({
              value: option.priorityid,
              label: option.name,
            }))}
            onChange={(newPriorityId) => {
              if (Number(newPriorityId) === Number(currentPriorityId)) {
                return;
              }

              updateTaskPriority(record.id, newPriorityId);
            }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: "9px",
                  }}
                />

                <span>{option.data.label}</span>
              </div>
            )}
            labelRender={() => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: priorityColor,
                    fontSize: "9px",
                  }}
                />

                <span>
                  {selectedPriority?.name || priorityName || "Select priority"}
                </span>
              </div>
            )}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("view", record);
                }}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>

            <li>
              <Link
                to="#"
                className="dropdown-item"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <Edit className="info-img text-info" />
                Edit
              </Link>
            </li>
          </ul> */}
          <div className="action-table-data">
            <div className="edit-delete-action " title="Edit">
              <Link
                to="#"
                className="me-2 p-2 shadow-sm"
                onClick={(event) => {
                  event.preventDefault();
                  openTaskDetail("edit", record);
                }}
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [tasks, setTasks] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [openAddTask, setOpenAddTask] = useState(false);

  const [detailDrawer, setDetailDrawer] = useState({
    open: false,
    mode: "view",
    taskId: null,
  });

  const [taskStatusOptions, setTaskStatusOptions] = useState([]);
  const [statusOptionsLoading, setStatusOptionsLoading] = useState(false);
  const [updatingStatusTaskId, setUpdatingStatusTaskId] = useState(null);

  const [priorityOptions, setPriorityOptions] = useState([]);
  const [priorityOptionsLoading, setPriorityOptionsLoading] = useState(false);
  const [updatingPriorityTaskId, setUpdatingPriorityTaskId] = useState(null);

  const avatarColors = [
    { background: "#E7F1FF", color: "#0D6EFD" },
    { background: "#E8F8F0", color: "#198754" },
    { background: "#FFF4DE", color: "#FF9800" },
    { background: "#FDECEC", color: "#DC3545" },
    { background: "#E8F7FA", color: "#0DCAF0" },
    { background: "#F3E8FF", color: "#6F42C1" },
  ];

  const fetchTaskStatuses = async () => {
    try {
      setStatusOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}tasks/GetTaskStatus`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("STATUS API:", result);

      setTaskStatusOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching task statuses:", error);
      setTaskStatusOptions([]);
    } finally {
      setStatusOptionsLoading(false);
    }
  };

  const fetchPriorities = async () => {
    try {
      setPriorityOptionsLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetPriorities`);

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      console.log("PRIORITY API:", result);

      setPriorityOptions(
        Array.isArray(result?.ResultData) ? result.ResultData : [],
      );
    } catch (error) {
      console.error("Error fetching priorities:", error);
      setPriorityOptions([]);
    } finally {
      setPriorityOptionsLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskStatuses();
    fetchPriorities();
  }, []);

  const getTasks = async () => {
    try {
      setTaskLoading(true);

      let query = "";

      switch (type) {
        case "proposal":
          query = `proposalId=${recordId}`;
          break;

        case "estimate":
          query = `estimateId=${recordId}`;
          break;

        case "invoice":
          query = `invoiceId=${recordId}`;
          break;

        case "creditnote":
          query = `creditnoteId=${recordId}`;
          break;

        default:
          return;
      }

      const response = await fetch(`${BASE_CRM_URL}tasks/GetTasksnew?${query}`);

      const data = await response.json();

      setTasks(data.Status ? data.ResultData || [] : []);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setTasks([]);
    } finally {
      setTaskLoading(false);
    }
  };

  const updateTaskStatus = async (taskId, statusId) => {
    try {
      setUpdatingStatusTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskStatus`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          status: statusId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update status");
      }

      message.success("Task status updated successfully");

      await Promise.all([getTasks(recordId)]);
    } catch (error) {
      console.error("Error updating task status:", error);

      message.error("Failed to update task status");
    } finally {
      setUpdatingStatusTaskId(null);
    }
  };

  const updateTaskPriority = async (taskId, priorityId) => {
    try {
      setUpdatingPriorityTaskId(taskId);

      const response = await fetch(`${BASE_CRM_URL}tasks/UpdateTaskPriority`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Id: taskId,
          priority: priorityId,
        }),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const result = await response.json();

      if (result?.Status === false) {
        throw new Error(result?.Message || "Failed to update priority");
      }

      message.success("Task priority updated successfully");

      await getTasks(recordId);
    } catch (error) {
      console.error("Error updating task priority:", error);

      message.error("Failed to update task priority");
    } finally {
      setUpdatingPriorityTaskId(null);
    }
  };

  useEffect(() => {
    if (recordId && type) {
      getTasks();
    }
  }, [recordId, type]);

  const openTaskDetail = (mode, record) => {
    setDetailDrawer({ open: true, mode, taskId: record?.id });
  };

    const closeTaskDetail = () => {
      setDetailDrawer((prev) => ({ ...prev, open: false }));
    };
    const handleEditTaskSuccess = async () => {
      setDetailDrawer((prev) => ({ ...prev, open: false }));
      await Promise.all([getTasks(recordId)]);
      message.success("Task updated successfully");
    };
  return (
    <div className="pt-3">
      <div className="card table-list-card">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <div className="search-set"></div>
          <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div className="dropdown me-2">
              {/* <Link
                to="#"
                className="btn btn-white btn-md d-inline-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#add-units"
              >
                <i className="ti ti-filter me-1"></i>
              </Link> */}
            </div>
            <div className="d-flex justify-content-end">
              <div className="me-3" title="addtask">
                <button
                  to="#"
                  onClick={() => setOpenAddTask(true)}
                  className="btn btn-success btn-sm"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className=" table-responsive">
            {taskLoading ? (
              <div
                className="d-flex justify-content-center align-items-center py-5"
                style={{ minHeight: "250px" }}
              >
                <Spin />
              </div>
            ) : (
              <Table columns={columns} dataSource={tasks} />
            )}
          </div>
        </div>

        <NewTask
          open={openAddTask}
          onClose={() => setOpenAddTask(false)}
          type={type}
          id={recordId}
          onSuccess={async () => {
            setOpenAddTask(false);
            await getTasks();
          }}
        />

        <TaskDetailDrawer
          mode={detailDrawer.mode}
          taskId={detailDrawer.taskId}
          open={detailDrawer.open}
          onClose={closeTaskDetail}
          onSuccess={handleEditTaskSuccess}
          type={type}
          id={recordId}
        />
      </div>
    </div>
  );
};
Tasks.propTypes = {
  recordId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  type: PropTypes.string,
};

export default Tasks;
